// extracted by mini-css-extract-plugin
export default {"Container":"privacyPolicy_Container__VvMwZ"};